import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { translate } from 'googleapis/build/src/apis/translate';

export const RushWrapper = styled(Box)(({ theme }) => ({}));
export const RushContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  paddingTop: theme.spacing(4),
  // marginBottom: theme.spacing(2),
}));

export const RushGameBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: theme.spacing(4),
  flex: 1,
  height: '460px',
  paddingBottom: 0,
  borderRadius: '8px',
  overflow: 'hidden',
  position: 'relative',
  order: 0,
  [theme.breakpoints.down('lg')]: {
    marginRight: '1px',
  },
  [theme.breakpoints.down('md')]: {
    flex: 'auto',
    marginRight: 0,
    width: '100%',
    padding: 0,
    height: '280px',
  },
}));

export const RushGameBoxTop = styled(Box)(({ theme }) => ({}));
export const RushGameBoxCore = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
}));
export const LuckPotMenuWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '260px',
  margin: '0 auto',
  left: 0,
  right: 0,
  bottom: '8px',
  // transform: `translateY(-45%)`,
  [theme.breakpoints.down('lg')]: {
    // transform: `translateY(-400%)`,
  },
  [theme.breakpoints.down('md')]: {
    // transform: `translateY(-500%)`,
    marginTop: 0,
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    // transform: `translateY(-50%)`,
  },
}));
export const LuckPotMenuWrapperTablet = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  // top: '220px',
  width: '42%',
  bottom: '8px',
  margin: '0 auto',
  left: 0,
  right: 0,
  marginTop: 0,
  transform: 'scale(0.78)',
}));
export const SpinWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    background: theme.palette.bg.secondary,
    padding: '10px 12px 15px 12px ',
    borderRadius: '8px',
    border: '1px solid #EEA433',
    borderBottom: 'none',
    width: '100%',
    zIndex: 3,
    bottom: '0', //底部menu高度
  },
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    background: theme.palette.bg.secondary,
    padding: '5px 12px 15px 12px ',
    borderRadius: '8px',
    border: '1px solid #EEA433',
    borderBottom: 'none',
    width: '100%',
    zIndex: 3,
    bottom: '60px', //底部menu高度
  },
}));
